export default "__VITE_ASSET__Yb8x8g1k__"